export const YEARLY_DISCOUNT_LABEL = "Save 20%";

export const PRICING_GROUPS = [
    {
        id: "bots",
        name: "Forex Trading Bots",
        interest: "Forex Trading Bots",
        blurb: "Licensed expert advisors for gold, oil and index markets. Every plan includes setup guidance and update access.",
        billing: "recurring",
        tiers: [
            {
                id: "bots-starter",
                name: "Starter",
                monthly: 99,
                yearly: 79,
                summary: "One bot, one market. The disciplined way in.",
                features: [
                    "1 expert advisor licence (XAU/USD)",
                    "1 live account connection",
                    "Quarterly strategy updates",
                    "Setup guide + email support",
                ],
            },
            {
                id: "bots-pro",
                name: "Pro",
                monthly: 249,
                yearly: 199,
                featured: true,
                summary: "The full stable across gold, oil and indices.",
                features: [
                    "3 expert advisor licences (XAU, WTI, indices)",
                    "Up to 3 live account connections",
                    "Monthly strategy updates",
                    "VPS configuration assistance",
                    "Priority desk support",
                ],
            },
            {
                id: "bots-elite",
                name: "Elite",
                monthly: 499,
                yearly: 399,
                summary: "Every bot we run, tuned to your risk mandate.",
                features: [
                    "All current + future expert advisors",
                    "Unlimited account connections",
                    "Custom risk-parameter tuning",
                    "Quarterly 1-on-1 portfolio review",
                    "Direct line to the desk",
                ],
            },
        ],
    },
    {
        id: "signals",
        name: "Forex Signals",
        interest: "Forex Signals",
        blurb: "High-conviction setups across commodities, indices and ETFs — entry, stop and targets on every call.",
        billing: "recurring",
        tiers: [
            {
                id: "signals-access",
                name: "Access",
                monthly: 49,
                yearly: 39,
                summary: "The core signal feed, nothing held back.",
                features: [
                    "5–10 curated setups per week",
                    "Entry, stop-loss and take-profit levels",
                    "Commodities + index coverage",
                    "Monthly performance report",
                ],
            },
            {
                id: "signals-pro",
                name: "Pro",
                monthly: 129,
                yearly: 103,
                featured: true,
                summary: "The feed plus the reasoning behind it.",
                features: [
                    "Everything in Access",
                    "Full trade rationale with chart context",
                    "ETF swing-trade coverage",
                    "Real-time alert delivery",
                    "Weekly desk commentary",
                ],
            },
        ],
    },
    {
        id: "education",
        name: "Trading Education",
        interest: "Trading Education",
        blurb: "Structured curriculum built by operators who trade what they teach. One-time enrolment, lifetime access.",
        billing: "one-time",
        tiers: [
            {
                id: "edu-foundations",
                name: "Foundations",
                oneTime: 299,
                summary: "From zero to a rules-based process.",
                features: [
                    "12-module core curriculum",
                    "Risk & position-sizing masterclass",
                    "Strategy playbooks: gold, oil, indices",
                    "Lifetime access + updates",
                ],
            },
            {
                id: "edu-masterclass",
                name: "Masterclass",
                oneTime: 799,
                featured: true,
                summary: "The full curriculum with a mentor beside you.",
                features: [
                    "Everything in Foundations",
                    "8 weeks of live market webinars",
                    "Personal trade reviews",
                    "1-on-1 mentorship from desk traders",
                    "Private alumni community",
                ],
            },
        ],
    },
];

export const PRICING_TEASER = PRICING_GROUPS.map((g) => ({
    id: g.id,
    name: g.name,
    from: g.billing === "one-time" ? g.tiers[0].oneTime : g.tiers[0].monthly,
    suffix: g.billing === "one-time" ? "one-time" : "/mo",
}));
